/* Load the same versioned calendar asset used by the Shopify theme. */
try {
  const script=document.querySelector('script[data-lafermu-doofinder-calendar]');
  await import(script?.dataset.lafermuDoofinderCalendar || new URL('./cro-business-calendar.js',import.meta.url).href);
} catch (error) {
  console.warn('Lafermu: no se ha podido cargar el calendario de entrega de Doofinder.');
}
/* Lafermu Doofinder adapter. Uses the existing Shopify business calendar. */
(() => {
  'use strict';
  function integer(value) {
    if(value === null || value === undefined || String(value).trim() === '') return null;
    if(!/^-?\d+$/.test(String(value).trim())) return null;
    const n=Number(value);
    return Number.isSafeInteger(n)?n:null;
  }
  function model(data, calendar, now=new Date()) {
    const qty=integer(data.quantity);
    const availability=String(data.availability||'').trim().toLowerCase().replace(/[_-]/g,' ');
    const unknown={state:'unknown',label:'Consultar disponibilidad',date:''};
    const grouped=data.grouped==='true';
    if(availability==='out of stock') return {state:'soldout',label:'Agotado',date:''};
    if(!['in stock','backorder','preorder'].includes(availability)||qty===null) return unknown;
    const state=qty>0 && availability==='in stock'?'stock':'manufacturing';
    const lead=state==='stock'?0:integer(data.lead);
    // Positive stock on a grouped result does not mean every variant is in stock.
    const label=state==='stock'?(grouped?'En stock en algunas variantes':'En stock'):'Bajo pedido';
    if(lead===null||lead<0||lead>36500) return {state,label,date:'Consulta el plazo de entrega'};
    const range=calendar?.deliveryWindow(lead,now);
    const message=range?`${state==='stock'?'Recíbelo':'Entrega estimada'} entre el ${range.text}.`:'Consulta la fecha de entrega';
    return {state,label,date:range && grouped ? `${message} ${state==='stock'?'Para variantes con stock.':'Según variante elegida.'}` : message};
  }
  if(typeof module!=='undefined'&&module.exports){module.exports={model,integer};return;}
  if(customElements.get('lafermu-doofinder-stock')) return;
  class DoofinderStock extends HTMLElement {
    static get observedAttributes(){return ['data-quantity','data-availability','data-lead','data-grouped'];}
    connectedCallback(){
      this.observer=new MutationObserver(()=>this.schedule());
      this.observer.observe(this,{childList:true,subtree:true,characterData:true});
      this.schedule();
      clearInterval(this.timer);
      this.timer=setInterval(()=>{if(!document.hidden)this.schedule();},60000);
    }
    disconnectedCallback(){clearInterval(this.timer);this.observer?.disconnect();}
    attributeChangedCallback(){if(this.isConnected)this.schedule();}
    schedule(){
      if(this.pending)return;
      this.pending=true;
      queueMicrotask(()=>{this.pending=false;if(this.isConnected)this.render();});
    }
    render(){
      const label=this.querySelector('.lf-df-stock-label'),date=this.querySelector('.lf-df-stock-date');
      if(!label||!date)return;
      const result=model(this.dataset,globalThis.LafermuCalendar);
      if(this.dataset.state!==result.state)this.dataset.state=result.state;
      if(label.textContent!==result.label)label.textContent=result.label;
      if(date.textContent!==result.date)date.textContent=result.date;
      date.hidden=!result.date;
    }
  }
  customElements.define('lafermu-doofinder-stock',DoofinderStock);
})();
